/* ce-cart.js: the small extras of the cart (owner: the product builder).
   Dawn's cart.js and cart-drawer.js still do all the cart work; this file only adds:
   1. [data-ce-cd-count]       "3 items" beside the cart headings, kept right after any cart change
   2. [data-ce-cart-recs]      the cart page's "You might also like" rail: swaps the fallback collection for
                               Shopify's recommendations for the first item (Section Rendering API), when there
                               are at least two; refetches if the first item changes
   3. [data-ce-cs-bar]         the phone checkout bar on /cart: shown while the summary's own Check out button
                               ([data-ce-cs-checkout]) is out of view, hidden for an empty cart
   Loaded (deferred) by snippets/cart-drawer.liquid, or by main-cart-items when the cart type is not a drawer.
   Idempotent: it binds once per element and again after the theme editor reloads a section. */
(function () {
  'use strict';
  if (window.__boCart) return;
  window.__boCart = true;

  var D = document;
  var words = function (n) { return n > 0 ? n + (n === 1 ? ' item' : ' items') : ''; };

  /* 1. counts */
  function paintCounts(cart) {
    if (!cart) return;
    D.querySelectorAll('[data-ce-cd-count]').forEach(function (el) {
      var t = words(cart.item_count);
      if (el.textContent.trim() !== t) el.textContent = t;
    });
  }

  /* 2. recommendations */
  function loadRecs(box, productId) {
    var url = box.getAttribute('data-url');
    var sec = box.getAttribute('data-section');
    if (!url || !sec || !productId) return;
    box.setAttribute('data-product', productId);
    var q = url + (url.indexOf('?') > -1 ? '&' : '?') +
      'product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(box.getAttribute('data-limit') || '12') +
      '&section_id=' + encodeURIComponent(sec) +
      '&intent=' + encodeURIComponent(box.getAttribute('data-intent') || 'related');
    fetch(q, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ce-cart-recs-track]');
        var track = box.querySelector('[data-ce-cart-recs-track]');
        if (!fresh || !track) return;
        if (fresh.querySelectorAll(':scope > li').length < 2) return; // keep the collection
        var root = box.querySelector('.ce-container') || box;
        if (window.BO && BO.release) BO.release(root);
        track.innerHTML = fresh.innerHTML;
        track.scrollLeft = 0;
        if (window.BO && BO.init) BO.init(root);
        box.classList.add('is-recommended');
      })
      .catch(function () { /* the collection stays: nothing lost */ });
  }

  function bindRecs(scope) {
    (scope || D).querySelectorAll('[data-ce-cart-recs][data-url]').forEach(function (box) {
      if (box.__boBound) return;
      box.__boBound = true;
      var id = box.getAttribute('data-product');
      if (!id) return;
      var go = function () { loadRecs(box, id); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
        }, { rootMargin: '600px 0px' });
        io.observe(box);
      } else { go(); }
    });
  }

  function recsFollow(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    var first = String(cart.items[0].product_id);
    D.querySelectorAll('[data-ce-cart-recs][data-url]').forEach(function (box) {
      if (box.getAttribute('data-product') !== first) loadRecs(box, first);
    });
  }

  /* 3. phone checkout bar */
  function bindBar(scope) {
    (scope || D).querySelectorAll('[data-ce-cart-summary]').forEach(function (sum) {
      var bar = sum.querySelector('[data-ce-cs-bar]');
      var btn = sum.querySelector('[data-ce-cs-checkout]');
      if (!bar || !btn || bar.__boBound) return;
      bar.__boBound = true;
      bar.hidden = false;
      var mq = window.matchMedia('(max-width: 999px)');
      var seen = true;
      var empty = sum.classList.contains('is-empty');
      var set = function () {
        var on = mq.matches && !seen && !empty;
        bar.classList.toggle('is-on', on);
        bar.inert = !on;
        D.documentElement.classList.toggle('ce-cs-bar-on', on);
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          seen = entries[entries.length - 1].isIntersecting;
          set();
        }, { threshold: 0.4 }).observe(btn);
      }
      if (mq.addEventListener) mq.addEventListener('change', set);
      D.addEventListener('ce:cart:updated', function (e) {
        var c = e.detail && e.detail.cart;
        if (c) { empty = c.item_count === 0; set(); }
      });
      set();
    });
  }

  /* 4. the drawer: its rows rise in once each time it OPENS (not on every quantity change) */
  function bindDrawer() {
    var drawer = D.querySelector('cart-drawer.ce-cd');
    if (!drawer || drawer.__boBound || !('MutationObserver' in window)) return;
    drawer.__boBound = true;
    var was = drawer.classList.contains('active'), t, since = 0;
    var stop = function () { clearTimeout(t); drawer.classList.remove('ce-cd--opening'); };
    // fix round 10-10 (speed): html.ce-cd-open while the drawer is open, for the CSS that steps the chat bubble and
    // the app pop-ups aside (it was body:has(cart-drawer.active): a whole-page restyle on any change anywhere)
    D.documentElement.classList.toggle('ce-cd-open', was);
    new MutationObserver(function () {
      var now = drawer.classList.contains('active');
      if (now !== was) D.documentElement.classList.toggle('ce-cd-open', now);
      if (now && !was) {
        drawer.classList.add('ce-cd--opening');
        drawer.classList.add('ce-cd--seen');   // images audit 02-10: the empty cart's "Best sellers" may load now (ce-cart.css)
        since = Date.now();
        clearTimeout(t);
        t = setTimeout(stop, 1000);
      }
      was = now;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    // Dawn re-renders the drawer's insides (#CartDrawer) after a change. A row put in while the drawer is
    // still "opening" would start its settle again, so the settle ends the moment anything is re-rendered.
    var inner = D.getElementById('CartDrawer') || drawer;
    new MutationObserver(function () {
      if (drawer.classList.contains('ce-cd--opening') && Date.now() - since > 80) stop();
    }).observe(inner, { childList: true, subtree: true });
  }

  function bind(scope) { bindRecs(scope); bindBar(scope); bindDrawer(); }

  /* 5. the cart page keeps up with changes made elsewhere (phone review 02-10).
     a. A quick Add from a card (a spare jug, "You might also like"): Dawn re-draws the lines but not the summary, which
        kept the old subtotal while the checkout bar showed the new one. The summary's subtotal block (.js-contents) is
        swapped; the Check out button the bar watches sits outside it.
     b. On this page the cart IS the page: the header's cart icon goes to it (a plain link, no drawer over it), and a
        quick Add here does not open the drawer (ce-main.js). If the drawer opens anyway and the cart is changed in it,
        the lines and the summary are re-drawn when it closes: the page's own Check out sends the quantities the page
        shows, so a stale page could have undone a change made in the drawer. */
  var sumRun = 0;
  var onCartPage = function () { return D.body.classList.contains('ce-page-cart') && !!D.getElementById('main-cart-footer'); };
  function refreshCartPage(withLines) {
    var box = D.getElementById('main-cart-footer');
    var sec = box && box.getAttribute('data-id');
    var list = withLines ? D.querySelector('cart-items') : null;
    var lwrap = list && list.querySelector('#main-cart-items');
    var lsec = lwrap && lwrap.getAttribute('data-id');
    var ids = [sec, lsec].filter(Boolean);
    if (!ids.length) return;
    var mine = ++sumRun;
    var base = (window.routes && window.routes.cart_url) || '/cart';
    fetch(base + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || mine !== sumRun) return;
        var parse = function (id) { return data[id] ? new DOMParser().parseFromString(data[id], 'text/html') : null; };
        var doc = sec ? parse(sec) : null;
        if (doc) {
          var from = doc.querySelector('#main-cart-footer .js-contents'), to = box.querySelector('.js-contents');
          if (from && to) to.innerHTML = from.innerHTML;
          var src = doc.getElementById('main-cart-footer');
          if (src) box.classList.toggle('is-empty', src.classList.contains('is-empty'));
        }
        var ldoc = lsec ? parse(lsec) : null;
        var lfrom = ldoc && ldoc.querySelector('cart-items');
        if (lfrom) { list.innerHTML = lfrom.innerHTML; list.classList.toggle('is-empty', lfrom.classList.contains('is-empty')); }
      })
      .catch(function () { /* the next change, or a reload, puts it right */ });
  }
  // b: the header's cart icon on this page is a plain link (stopped before the drawer's own click handler sees it)
  D.addEventListener('click', function (e) {
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || !onCartPage()) return;
    if (e.target.closest && e.target.closest('#cart-icon-bubble')) e.stopPropagation();
  }, true);
  // b: a drawer that was opened and changed here re-draws the page when it closes
  (function () {
    var drawer = D.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var open = drawer.classList.contains('active'), changed = false;
    D.addEventListener('ce:cart:updated', function () { if (open) changed = true; });
    new MutationObserver(function () {
      var now = drawer.classList.contains('active');
      if (open && !now && changed && onCartPage()) refreshCartPage(true);
      if (now && !open) changed = false;
      open = now;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  })();

  D.addEventListener('ce:cart:updated', function (e) {
    var c = e.detail && e.detail.cart;
    paintCounts(c);
    recsFollow(c);
    if (e.detail && e.detail.source === 'ce-quick-add' && onCartPage()) refreshCartPage(false);
  });
  D.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { bind(D); });
  else bind(D);
})();
